<!-- NotFound.vue -->
<template>
  <div class="not-found-container">
    <h1 class="error-code">404</h1>
    <p class="error-message">Halaman tidak ditemukan.</p>
    <p class="suggestion-text">Mungkin Anda ingin menuju salah satu halaman berikut:</p>
    <div class="navigation-links">
      <RouterLink v-for="link in links" :key="link.name" :to="link.path" class="nav-link">
        {{ link.name }}
      </RouterLink>
    </div>
  </div>
</template>

<script setup>
const links = [
  { name: 'Home', path: '/' },
  { name: 'Artikel', path: '/articles' },
  { name: 'Halaman Dokter', path: '/dokter' },
  { name: 'Layanan', path: '/layanan' },
  { name: 'Promo', path: '/promo' },
]
</script>

<style scoped>
.not-found-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  padding: 24px;
  text-align: center;
  background-color: #f9f9f9;
}

.error-code {
  font-size: 72px;
  font-weight: bold;
  color: #d9534f;
  margin: 1rem 0;
}

.error-message {
  font-size: 24px;
  color: #333;
  margin-bottom: 12px;
}

.suggestion-text {
  font-size: 16px;
  color: #666;
  margin-bottom: 24px;
}

.navigation-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.nav-link {
  display: inline-block;
  padding: 10px 20px;
  background-color: var(--primary);
  color: var(--white);
  text-decoration: none;
  border-radius: 6px;
  transition: background-color 0.3s ease;
}

.nav-link:hover {
  background-color: var(--primary-hover);
}
</style>
